<template>
    <div id="tickets">
       <v-container  class="justify-center mt-4">
            <v-row class="justify-center">
                <h1>Wykupione wejściówki</h1>
            </v-row>
            <v-row>
               <v-col cols="12" xs="12">
                   <Ticket v-for="item in tickets" :key="item.leagueId" :league_id="item.leagueId"/>
               </v-col>
           </v-row>
       </v-container>
    </div>
</template>
<script>
import Ticket from '@/components/Ticket'
export default {
    name:'tickets',
    components:{Ticket},
    data(){
        return{
           
        }
    },
    computed:{
        tickets(){
            return  this.$store.state.userData.tickets
        }
    }
}
</script>